import { render, staticRenderFns } from "./tipspointsale.vue?vue&type=template&id=cb4b5dac&scoped=true"
import script from "./tipspointsale.vue?vue&type=script&lang=js"
export * from "./tipspointsale.vue?vue&type=script&lang=js"
import style0 from "./tipspointsale.vue?vue&type=style&index=0&id=cb4b5dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b5dac",
  null
  
)

export default component.exports